import r from "styled-components";
const p = r.div``;
export {
  p as Wrapper
};
